<template>
  <table cellspacing="1" cellpadding="8">
    <thead>
      <tr>
        <td v-for="r in th" :key="r">{{ r }}</td>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index1) in data" :key="index1">
        <td v-for="(d, index2) in item" :key="index2">{{ d | decimal }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    th: {
      default: function () {
        return [];
      },
    },
    data: {
      default: function () {
        return [];
      },
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  text-align: center;
  font-size: 14px;
  thead > tr {
    color: #333;
    background: rgb(229, 255, 241);
  }
  tbody > tr > td {
    border-bottom: 1px solid #eee;
  }
}
</style>